import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

export default class extends Controller {
  static values = {
    content: String,
    allowHtml: { type: Boolean, default: false },
    theme: { type: String, default: "stonksfolio" }
  }

  connect() {
    this.tippyInstance = tippy(this.element, {
      content: this.contentValue,
      allowHTML: this.allowHtmlValue,
      theme: this.themeValue,
      placement: "bottom",
      interactive: true,
      appendTo: document.body
    })
  }

  disconnect() {
    this.tippyInstance?.destroy()
  }

  contentValueChanged() {
    this.tippyInstance?.setContent(this.contentValue)
  }
}
